var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var TextFieldMatrix = /** @class */ (function () {
    function TextFieldMatrix() {
    }
    Object.defineProperty(TextFieldMatrix, "buildTemplate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            var shield = data.shield, sections = data.sections;
            if (!shield) {
                return null;
            }
            var shieldSections = Object.values(sections).reduce(function (acc, section) {
                var _a;
                if (shield.id === section.shieldId) {
                    return __assign(__assign({}, acc), (_a = {}, _a[section.id] = section, _a));
                }
                return acc;
            }, {});
            var sectionArray = Object.values(shieldSections);
            if (sectionArray.length === 0) {
                return null;
            }
            // 1. Group sections by Y coordinate to identify rows
            var rowsMap = sectionArray.reduce(function (acc, s) {
                var y = s.y.toFixed(10);
                if (!acc[y]) {
                    acc[y] = [];
                }
                acc[y].push(s);
                return acc;
            }, {});
            var sortedY = Object.keys(rowsMap).sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
            // 2. Extract detailed info for each row
            var rowInfo = sortedY.map(function (yStr) {
                var sectionsInRow = rowsMap[yStr].sort(function (a, b) { return a.x - b.x; });
                return {
                    y: parseFloat(yStr),
                    columnCount: sectionsInRow.length,
                    xPositions: sectionsInRow.map(function (s) { return s.x; }),
                    widths: sectionsInRow.map(function (s) { return s.width; }),
                    height: Math.max.apply(Math, __spreadArray([], __read(sectionsInRow.map(function (s) { return s.height; })), false)),
                    sectionIds: sectionsInRow.map(function (s) { return s.id; }),
                };
            });
            // 3. Calculate global matrix properties
            var totalLines = rowInfo.length;
            var maxCols = Math.max.apply(Math, __spreadArray([], __read(rowInfo.map(function (r) { return r.columnCount; })), false));
            var template = {
                totalRowsNumber: totalLines,
                maxColumnsNumber: maxCols,
                rows: rowInfo,
            };
            return template;
        }
    });
    return TextFieldMatrix;
}());
export default TextFieldMatrix;
